// src/components/SupportCallout.jsx
import * as React from "react";
import { Paper, Typography, Button } from "@mui/material";
import { gaEvent } from "../analytics";

export default function SupportCallout({ onOpen }) {
  return (
    <Paper
      elevation={6}
      sx={{
        p: 3,
        borderRadius: 3,
        overflow: "hidden",
        position: "relative",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(255,255,255,0.92))",
        boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
      }}
    >
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        Στήριξε το εγχείρημα
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
        Αν το TeacherOnTheRoad σε βοηθά να οργανώνεις τις επιλογές σου,
        μπορείς να στηρίξεις άμεσα την εξέλιξή του.
      </Typography>

      <Button
        variant="contained"
        sx={{ textTransform: "none" }}
        onClick={() => {
          // Μετράμε πόσοι πατάνε το "Buy me a coffee" (άνοιγμα παραθύρου)
          gaEvent("buy_me_a_coffee_click", { placement: "callout" });
          onOpen?.();
        }}
      >
        ☕ Buy me a coffee
      </Button>

    </Paper>
  );
}
